import {
  Box, Button, Icon,
  Paper, Typography, useTheme,
  FormControl,
  Select,
  MenuItem,
  FormControlLabel,
  RadioGroup as MuiRadioGroup,
  InputLabel,
  FormLabel,
  Radio,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { ptBR } from '@mui/x-data-grid/locales';
import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { FerramentasDaListagem } from "../../shered/components";
import { useDebounce } from "../../shered/hooks";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { ILstDrop, UtilidadeService, tipoConfronto } from "../../shered/services/api/utilidades/UtilidadesService";
import { IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";
import { Loading } from "../../shered/components/loading/Loading";
import { DataGrid, GridColDef, GridEventListener } from "@mui/x-data-grid";
import { EstatisticasService, IDadosRetornoHistorico, IListaDadosHistoricoConfrontos } from "../../shered/services/api/estatisticas/EstatisticasService";
import { FranquiaService } from "../../shered/services/api/franquia/FranquiaService";

const tiposFiltro = [
  {
    codigo: 1,
    label: "Time"
  },
  {
    codigo: 2,
    label: "GM"
  },

];

const columnsGeral: GridColDef[] = [
  // {
  //   field: 'codigo',
  //   headerName: '',
  //   flex: 1,
  //   minWidth: 40,
  //   maxWidth: 40,
  //   headerClassName: 'super-app-theme--header',
  //   align: 'center',
  //   headerAlign: 'center',


  // },
  {
    field: 'descricao_Temporada',
    headerName: 'ANO',
    flex: 1,
    minWidth: 100,
    maxWidth: 100,
    headerClassName: 'super-app-theme--header'
  },
  // {
  //   field: 'foto',
  //   headerName: 'Foto',
  //   editable: false,
  //   flex: 1,
  //   minWidth: 65,
  //   maxWidth: 65,
  //   headerClassName: 'super-app-theme--header',
  //   renderCell: (params) => params.value !== null ? <img src={params.value} width={45} height={50} /> : null,
  // },
  {
    field: 'caminho_Logo_Franquia1',
    headerName: 'LOGO',
    flex: 1,
     sortable:  UtilidadeService.isMobile() ?false : true ,
    minWidth: 65,
    maxWidth: 65,
    renderCell: (params) => params.value !== null ? <img src={params.value} width={45} height={50} /> : null,
    headerClassName: 'super-app-theme--header'
  },
  {
    field: 'nome_Franquia1',
    headerName: 'FRANQUIA 1',
    headerClassName: 'super-app-theme--header',
    flex: 1,
     minWidth: UtilidadeService.isMobile() ? 140 : 220,
     sortable:  UtilidadeService.isMobile() ?false : true ,
    editable: false,

  },
  {
    field: 'vitoria_Franquia1',
    headerName: 'VITÓRIA',
    editable: false,
    flex: 1,
     sortable:  UtilidadeService.isMobile() ?false : true ,
    minWidth: 90,
    maxWidth: 90,
    headerClassName: 'super-app-theme--header',
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'empate',
    headerName: 'EMPATE',
    editable: false,
    headerClassName: 'super-app-theme--header',
    flex: 1,
     sortable:  UtilidadeService.isMobile() ?false : true ,
    minWidth: 90,
    maxWidth: 90,
    align: 'center',
    headerAlign: 'center',
    //cellClassName: 'super-app-theme--cell',
  },

  {
    field: 'vitoria_Franquia2',
    headerName: 'VITÓRIA',
    editable: false,
    headerClassName: 'super-app-theme--header',
    flex: 1,
     sortable:  UtilidadeService.isMobile() ?false : true ,
    minWidth: 90,
    maxWidth: UtilidadeService.isMobile() ? 140 : 120,
    align: 'center',
    headerAlign: 'center',
    //cellClassName: 'super-app-theme--cell',
  },
  {
    field: 'nome_Franquia2',
    headerName: 'FRANQUIA 2',
    editable: false,
    flex: 1,
     sortable:  UtilidadeService.isMobile() ?false : true ,
     minWidth: UtilidadeService.isMobile() ? 120 : 220,
    headerClassName: 'super-app-theme--header',
    headerAlign: "right",
    align: "right"
  },
  {
    field: 'caminho_Logo_Franquia2',
    headerName: 'LOGO',
    flex: 1,
     sortable:  UtilidadeService.isMobile() ?false : true ,
    minWidth: 65,
    maxWidth: 65,
    renderCell: (params) => params.value !== null ? <img src={params.value} width={45} height={50} /> : null,
    headerClassName: 'super-app-theme--header'
  },

];

const columnsGeralUsuario: GridColDef[] = [
  {
    field: 'codigo',
    headerName: '',
    flex: 1,
     sortable:  UtilidadeService.isMobile() ?false : true ,
    minWidth: 40,
    maxWidth: 40,
    headerClassName: 'super-app-theme--header',
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'descricao_Temporada',
    headerName: 'ANO',
    flex: 1,
     sortable:  UtilidadeService.isMobile() ?false : true ,
    minWidth: 100,
    maxWidth: 100,
    headerClassName: 'super-app-theme--header'
  },
  // {
  //   field: 'foto',
  //   headerName: 'Foto',
  //   editable: false,
  //   flex: 1,
  //   minWidth: 65,
  //   maxWidth: 65,
  //   headerClassName: 'super-app-theme--header',
  //   renderCell: (params) => params.value !== null ? <img src={params.value} width={45} height={50} /> : null,
  // },
  {
    field: 'caminho_Foto_Usuario_Franquia1',
    headerName: 'FOTO',
    flex: 1,
     sortable:  UtilidadeService.isMobile() ?false : true ,
    minWidth: 65,
    maxWidth: 65,
    renderCell: (params) => params.value !== null ? <img src={params.value} width={45} height={50} /> : null,
    headerClassName: 'super-app-theme--header'
  },
  {
    field: 'nome_Usuario_Franquia1',
    headerName: 'GM 1',
    headerClassName: 'super-app-theme--header',
    flex: 1,
     sortable:  UtilidadeService.isMobile() ?false : true ,    

  },
  {
    field: 'vitoria_Franquia1',
    headerName: 'VITÓRIA',
    editable: false,
    flex: 1,
      sortable:  UtilidadeService.isMobile() ?false : true , 
    minWidth: 90,
    maxWidth: 90,
    headerClassName: 'super-app-theme--header',
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'empate',
    headerName: 'EMPATE',
    editable: false,
    headerClassName: 'super-app-theme--header',
    flex: 1,
      sortable:  UtilidadeService.isMobile() ?false : true , 
    minWidth: 90,
    maxWidth: 90,
    align: 'center',
    headerAlign: 'center',
    //cellClassName: 'super-app-theme--cell',
  },

  {
    field: 'vitoria_Franquia2',
    headerName: 'VITÓRIA',
    editable: false,
    headerClassName: 'super-app-theme--header',
    flex: 1,
      sortable:  UtilidadeService.isMobile() ?false : true , 
    minWidth: 90,
    maxWidth: 90,
    align: 'center',
    headerAlign: 'center',
    //cellClassName: 'super-app-theme--cell',
  },
  {
    field: 'nome_Usuario_Franquia2',
    headerName: 'GM 2',
    editable: false,
    flex: 1,
      sortable:  UtilidadeService.isMobile() ?false : true , 
    headerClassName: 'super-app-theme--header',
    headerAlign: "right",
    align: "right"
  },
  {
    field: 'caminho_Foto_Usuario_Franquia2',
    headerName: 'FOTO',
    flex: 1,
      sortable:  UtilidadeService.isMobile() ?false : true , 
    minWidth: 65,
    maxWidth: 65,
    renderCell: (params) => params.value !== null ? <img src={params.value} width={45} height={50} /> : null,
    headerClassName: 'super-app-theme--header'
  },

];

const columnsGeralUsuarioDetalhes: GridColDef[] = [
  {
    field: 'codigo',
    headerName: '',
    flex: 1,
      sortable:  UtilidadeService.isMobile() ?false : true , 
    minWidth: 40,
    maxWidth: 40,
    headerClassName: 'super-app-theme--header',
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'logo_Liga',
    headerName: 'LOGO',
    editable: false,
    flex: 1,
      sortable:  UtilidadeService.isMobile() ?false : true , 
    minWidth: 65,
    maxWidth: 65,
    headerClassName: 'super-app-theme--header',
    renderCell: (params) => params.value !== null ? <img src={params.value} width={45} height={50} /> : null,
  },
  {
    field: 'nome_Liga',
    headerName: 'LIGA',
    editable: false,
    flex: 1,
      sortable:  UtilidadeService.isMobile() ?false : true , 
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'nome_Franquia1',
    headerName: 'FRANQUIA 1',
    headerClassName: 'super-app-theme--header',
    flex: 1,
      sortable:  UtilidadeService.isMobile() ?false : true , 
    editable: false,

  },
  {
    field: 'caminho_Logo_Franquia1',
    headerName: 'LOGO',
    flex: 1,
      sortable:  UtilidadeService.isMobile() ?false : true , 
    minWidth: 65,
    maxWidth: 65,
    renderCell: (params) => params.value !== null ? <img src={params.value} width={45} height={50} /> : null,
    headerClassName: 'super-app-theme--header'
  },
  {
    field: 'vitoria_Franquia1',
    headerName: 'VITÓRIA',
    editable: false,
    flex: 1,
      sortable:  UtilidadeService.isMobile() ?false : true , 
    minWidth: 90,
    maxWidth: 90,
    headerClassName: 'super-app-theme--header',
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'empate',
    headerName: 'EMPATE',
    editable: false,
    headerClassName: 'super-app-theme--header',
    flex: 1,
      sortable:  UtilidadeService.isMobile() ?false : true , 
    minWidth: 90,
    maxWidth: 90,
    align: 'center',
    headerAlign: 'center',
    //cellClassName: 'super-app-theme--cell',
  },

  {
    field: 'vitoria_Franquia2',
    headerName: 'VITÓRIA',
    editable: false,
    headerClassName: 'super-app-theme--header',
    flex: 1,
      sortable:  UtilidadeService.isMobile() ?false : true , 
    minWidth: 90,
    maxWidth: 90,
    align: 'center',
    headerAlign: 'center',
    //cellClassName: 'super-app-theme--cell',
  }, {
    field: 'caminho_Logo_Franquia2',
    headerName: 'LOGO',
    flex: 1,
      sortable:  UtilidadeService.isMobile() ?false : true , 
    minWidth: 65,
    maxWidth: 65,
    renderCell: (params) => params.value !== null ? <img src={params.value} width={45} height={50} /> : null,
    headerClassName: 'super-app-theme--header'
  },

  {
    field: 'nome_Franquia2',
    headerName: 'FRANQUIA 2',
    editable: false,
    flex: 1,
      sortable:  UtilidadeService.isMobile() ?false : true , 
    headerClassName: 'super-app-theme--header',
    headerAlign: "right",
    align: "right"
  },


];

export const ListagemDeHistoricoConfrontos: React.FC = () => {
  const theme = useTheme();
  const { themeName } = useAppThemeContext();
  const refTab = useRef<any>(null);
  const { debounce } = useDebounce();
  const [isLoading, setIsLoading] = useState(true);
  const [removeLoading, setRemoveLoading] = useState(false);
  const navigate = useNavigate();
  const { logout } = useAuthContext();
  const user = CookieService.get("access_user");
  let codLocal = localStorage.getItem("@codigoLiga");
  const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
  const [showImagemFranquia, setShowImagemFranquia] = useState<any>("../../semimagemescudo.png");
  //const [semImagem, setSemImagem] = useState<any>("../../../semimagem.png");
  const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
  const [showModalMensagem, setShowModalMensagem] = useState(false);
  const [redirecionar, setRedirecionar] = useState("");
  const [searchParams, SetSearchParams] = useSearchParams();
  const [temporadaFiltro, setTemporadaFiltro] = useState(0);
  const [tipoFiltro, setTipoFiltro] = useState(1);
  const [lstFraqnuias, setLstFranquias] = useState<ILstDrop[]>([]);
  const [lstGms, setLstGms] = useState<ILstDrop[]>([]);
  const [franquia1, setFranquia1] = useState(0);
  const [gm1, setGm1] = useState(0);
  const [franquia2, setFranquia2] = useState(0);
  const [gm2, setGm2] = useState(0);
  const [tipoSelecionadoTime, setTipoSelecionadoTime] = useState(true);
  const [tipoSelecionadoGM, setTipoSelecionadoGM] = useState(false);
  const [showDetalhes, setShowDetalhes] = useState(false);
  const [dadosEstatistica, setDadosEstatistica] = useState<IDadosRetornoHistorico>();
  const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);
  const [tipoConfrontoFiltro, setTipoConfrontoFiltro] = useState(1);
  const [estatisticasRows, setEstatisticasRows] = useState<IListaDadosHistoricoConfrontos[]>([]);
  const [detalhesEstatisticasRows, setDetalhesEstatisticasRows] = useState<IListaDadosHistoricoConfrontos[]>([]);
  const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
    acao: false,
    label: "",
    tipo: "error",
    mensagem: "Sessão Expirada!",
    display: "none",
    titulo: "Atenção"
  });

  const [showModalEvent, setShowModalEvent] = useState(false);
  const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
    acao: false,
    label: "",
    tipo: "info",
    mensagem: "Deseja ronovar com o jogador ",
    display: "none",
    titulo: "Atenção"
  });

  const [errors, setErrors] = useState({
    error: false,
    nomeFranquiaRef: "",
    showImagemFranquia: ""
  });


  useEffect(() => {
    setIsLoading(true);
    if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
      setShowModalMensagem(true);
      setDadosModalMensagem({
        acao: true,
        label: "",
        tipo: "warning",
        mensagem: "Favor selecionar uma liga!",
        display: "none",
        titulo: "Atenção"
      });
      setRedirecionar("/dashboard");
      return;
    } else {
      debounce(() => {
        UtilidadeService.getTemporadasLigaPorTipoQtd(Number(codigoLiga), 1, 5)
          .then((result) => {
            const tmps = result.data.dado;
            let lstTemporadasAux = tmps.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));
            setLstTemporadas(lstTemporadasAux);
          })
          .catch((errors) => {
            setShowModalMensagem(true);
            if (errors.response !== undefined) {
              if (errors.response.status === 401) {
                setDadosModalMensagem({
                  acao: true,
                  label: "",
                  tipo: "info",
                  mensagem: "Sessão expirada!",
                  display: "none",
                  titulo: "Atenção"
                });
                logout();
                setRedirecionar("0");
                return;
              }
              setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "error",
                mensagem: errors.response.data.mensagem,
                display: "none",
                titulo: "Atenção"
              });
              return;
            }

            setDadosModalMensagem({
              acao: true,
              label: "",
              tipo: "error",
              mensagem: "Não foi possível carregar os dados. Tente novamente mais tarde. Caso o problema persista, favor entrar em contato com a TI.",
              display: "none",
              titulo: "Atenção"
            });
            return;

          });

        FranquiaService.getByIdLiga(Number(codigoLiga))
          .then((result) => {
            const franquias = result.dado.sort((a, b) => a.nome > b.nome ? 1 : -1);
            let lstFranquiasAux = franquias.map((f, i) => ({ codigo: f.codigo, label: f.nome }));
            setLstFranquias(lstFranquiasAux);
            let lstGmAux = franquias.sort((a, b) => a.nome_Usuario > b.nome_Usuario ? 1 : -1).map((f, i) => ({ codigo: f.codigo_Usuario, label: f.nome_Usuario }));
            setLstGms(lstGmAux);
          })
          .catch((errors) => {
            setShowModalMensagem(true);
            if (errors.response.status === 401) {
              setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Sessão expirada!",
                display: "none",
                titulo: "Atenção"
              });
              logout();
              setRedirecionar("0");
              return;
            }
            setDadosModalMensagem({
              acao: true,
              label: "",
              tipo: "error",
              mensagem: errors.response.data.mensagem,
              display: "none",
              titulo: "Atenção"
            });
          });

        LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
          .then((result) => {
            setIsLoading(false);
            setRemoveLoading(true);
            const liga = result.dado;
            setDadosLiga(liga);
            if (liga.caminho_Logo !== null) {
              setShowImagemFranquia(liga.caminho_Logo);
            }

            // carregarDadosHistoricoConfrontos(Number(codigoLiga), liga.codigo_Temporada, 2);
          })
          .catch((errors) => {
            setShowModalMensagem(true);
            setRemoveLoading(true);
            if (errors.response.status === 401) {
              setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Sessão expirada!",
                display: "none",
                titulo: "Atenção"
              });
              logout();
              setRedirecionar("0");
              return;
            }

            setDadosModalMensagem({
              acao: true,
              label: "",
              tipo: "error",
              mensagem: errors.response.data.mensagem,
              display: "none",
              titulo: "Atenção"
            });
            setRedirecionar(`/usuario/liga/${codLocal}`);
            return;
          });
      })
    }
  }, []);

  const carregarDadosHistoricoConfrontos = () => {
    setIsLoading(true);
    setRemoveLoading(false);

    if (tipoFiltro.toString() === "1") {
      EstatisticasService.getHistoricoConfrontosLiga(franquia1, franquia2, temporadaFiltro, tipoConfrontoFiltro)
        .then((result) => {
          const lstDados = result.dado;
          setEstatisticasRows(lstDados);
          setIsLoading(false);
          setRemoveLoading(true);
        })
        .catch((errors) => {
          setShowModalMensagem(true);
          setRemoveLoading(true);
          setIsLoading(false);
          if (errors.response) {
            if (errors.response.status === 401) {
              setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Sessão expirada!",
                display: "none",
                titulo: "Atenção"
              });
              logout();
              setRedirecionar("0");
              return;
            }

            setDadosModalMensagem({
              acao: true,
              label: "",
              tipo: "error",
              mensagem: errors.response.data.mensagem,
              display: "none",
              titulo: "Atenção"
            });
            return;
          }

          setDadosModalMensagem({
            acao: true,
            label: "",
            tipo: "error",
            mensagem: "Não foi possível carregar os dados! Tente novamente mais tarde e caso o problema persista, favor entrar em contato com a TI.",
            display: "none",
            titulo: "Atenção"
          });

          setRedirecionar(`/usuario/liga/${codLocal}`);
          return;
        });
    } else {
      EstatisticasService.getHistoricoConfrontosUsuario(gm1, gm2, temporadaFiltro, tipoConfrontoFiltro)
        .then((result) => {
          const dados = result.dado;
          setDadosEstatistica(dados);
          setEstatisticasRows(dados.historico_Confronto);
          setDetalhesEstatisticasRows(dados.detalhes_Historico_Confronto);
          setIsLoading(false);
          setRemoveLoading(true);
        })
        .catch((errors) => {
          setShowModalMensagem(true);
          setRemoveLoading(true);
          setIsLoading(false);
          if (errors.response) {
            if (errors.response.status === 401) {
              setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Sessão expirada!",
                display: "none",
                titulo: "Atenção"
              });
              logout();
              setRedirecionar("0");
              return;
            }

            setDadosModalMensagem({
              acao: true,
              label: "",
              tipo: "error",
              mensagem: errors.response.data.mensagem,
              display: "none",
              titulo: "Atenção"
            });
            return;
          }

          setDadosModalMensagem({
            acao: true,
            label: "",
            tipo: "error",
            mensagem: "Não foi possível carregar os dados! Tente novamente mais tarde e caso o problema persista, favor entrar em contato com a TI.",
            display: "none",
            titulo: "Atenção"
          });

          setRedirecionar(`/usuario/liga/${codLocal}`);
          return;
        });
    }
  }

  const toggleModalMensagem = () => {
    setShowModalMensagem(modalVisivel => !modalVisivel);
    if (redirecionar !== "") {
      redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
    }
  };

  const toggleModalEvent = () => {
    setShowModalEvent(modalVisivel => !modalVisivel);
    if (redirecionar !== "") {
      redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
    }
  }

  const handleChangeTipo = async (e: { target: { name: string; value: any; }; }) => {
    setTipoFiltro(e.target.value);
    setEstatisticasRows([]);
    setShowDetalhes(false);
    if (e.target.value === "1") {
      setTipoSelecionadoTime(true);
      setTipoSelecionadoGM(false);
    }
    else if (e.target.value === "2") {
      setTipoSelecionadoTime(false);
      setTipoSelecionadoGM(true);
    }
    //carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, e.target.value);
  }

  const handleChangeFranquia1 = async (e: { target: { name: string; value: any; }; }) => {
    setFranquia1(e.target.value);
    setEstatisticasRows([]);
    setDetalhesEstatisticasRows([]);
    setShowDetalhes(false);
  }

  const handleChangeFranquia2 = async (e: { target: { name: string; value: any; }; }) => {
    setFranquia2(e.target.value);
    setEstatisticasRows([]);
    setDetalhesEstatisticasRows([]);
    setShowDetalhes(false);

  }

  const handleChangeUsuario1 = async (e: { target: { name: string; value: any; }; }) => {
    setGm1(e.target.value);
    setEstatisticasRows([]);
    setDetalhesEstatisticasRows([]);
    setShowDetalhes(false);
  }

  const handleChangeUsuario2 = async (e: { target: { name: string; value: any; }; }) => {
    setGm2(e.target.value);
    setEstatisticasRows([]);
    setDetalhesEstatisticasRows([]);
    setShowDetalhes(false);

  }

  const handleRedirect: GridEventListener<'rowClick'> = (params) => {
    setShowDetalhes(true);
  }

  return (
    <LayoutBaseDePagina
      titulo={`Histórico Confrontos - ${dadosLiga?.nome}`}
      showLogoImg={showImagemFranquia}
      barraDeFerramentas={<FerramentasDaListagem
        textoBotaoNovo="Nova"
        mostrarBotaoNovo={false}
        mostrarInputBusca={false}
        aoMudarTextoDeBusca={texto => SetSearchParams({ busca: texto, pagina: "1" }, { replace: true })}
      />}>

      {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
      {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
      <Box margin={1} display="flex" component={Paper} variant="outlined"  >
        <Grid container size={{ xs: 12, sm: 12 }} sx={{ width: "100%" }}>
          <Grid container size={{ xs: 12, sm: 12 }} direction="column" padding={2} spacing={2} >
            <Grid container size={{ xs: 12, sm: 12 }} spacing={1}>
              <Grid size={{ xs: 12, sm: 12 }} >
                <Typography variant="h6"> Histórico de Confrontos </Typography>
                <hr />
              </Grid>
              <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="initial" spacing={2} paddingBottom={2} >
                <Grid size={{ xs: 12 }}>
                  <FormControl>
                    <FormLabel>Tipo</FormLabel>
                    <MuiRadioGroup
                      row
                      name="tipo"
                      value={tipoFiltro}
                      onChange={handleChangeTipo}
                    >
                      {
                        tiposFiltro.map(item => (<FormControlLabel key={item.codigo} value={item.codigo} control={<Radio />} label={item.label} />))
                      }
                    </MuiRadioGroup>
                  </FormControl >
                </Grid>
              </Grid>
              <Grid container size={{ xs: 12, sm: 12, md: 12 }} >
                {tipoSelecionadoTime && (
                  <>
                    <Grid size={{ xs: 12, sm: 2, md: 2 }} >
                      <FormControl fullWidth disabled={isLoading}>
                        <InputLabel id="demo-simple-select-label">Franquia 1</InputLabel>
                        <Select
                          variant="outlined"
                          native={false}
                          value={franquia1}
                          label="Franquia"
                          onChange={(e) => { setFranquia1(Number(e.target.value)); handleChangeFranquia1(e) }}
                        >
                          <MenuItem value={0}>Selecione</MenuItem>
                          {
                            lstFraqnuias.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                          }
                        </Select>
                      </FormControl >
                    </Grid>
                    <Grid size={{ xs: 12, sm: 2, md: 2 }} >
                      <FormControl fullWidth disabled={isLoading}>
                        <InputLabel id="demo-simple-select-label">Franquia 2</InputLabel>
                        <Select
                          variant="outlined"
                          native={false}
                          value={franquia2}
                          label="Franquia"
                          onChange={(e) => { setFranquia2(Number(e.target.value)); handleChangeFranquia2(e) }}
                        >
                          <MenuItem value={0}>Selecione</MenuItem>
                          {
                            lstFraqnuias.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                          }
                        </Select>
                      </FormControl >
                    </Grid>
                  </>
                )}
                {!tipoSelecionadoTime && (
                  <>
                    <Grid size={{ xs: 12, sm: 2, md: 2 }} >
                      <FormControl fullWidth disabled={isLoading}>
                        <InputLabel id="demo-simple-select-label">GM 1</InputLabel>
                        <Select
                          variant="outlined"
                          native={false}
                          value={gm1}
                          label="GM 1"
                          onChange={(e) => { setGm1(Number(e.target.value)); handleChangeUsuario1(e); }}
                        >
                          <MenuItem value={0}>Selecione</MenuItem>
                          {
                            lstGms.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                          }
                        </Select>
                      </FormControl >
                    </Grid>
                    <Grid size={{ xs: 12, sm: 2, md: 2 }} >
                      <FormControl fullWidth disabled={isLoading}>
                        <InputLabel id="demo-simple-select-label">GM 2</InputLabel>
                        <Select
                          variant="outlined"
                          native={false}
                          value={gm2}
                          label="GM 2"
                          onChange={(e) => { setGm2(Number(e.target.value)); handleChangeUsuario2(e); }}
                        >
                          <MenuItem value={0}>Selecione</MenuItem>
                          {
                            lstGms.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                          }
                        </Select>
                      </FormControl >
                    </Grid>
                  </>
                )}
                <Grid size={{ xs: 6, sm: 2, md: 2 }} >
                  <FormControl fullWidth disabled={isLoading}>
                    <InputLabel id="demo-simple-select-label">Temporadas</InputLabel>
                    <Select
                      variant="outlined"
                      native={false}
                      value={temporadaFiltro}
                      label="Temporadas"
                      onChange={(e) => setTemporadaFiltro(Number(e.target.value))}
                    >
                      <MenuItem value={0}>Todas</MenuItem>
                      {
                        lstTemporadas.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                      }

                    </Select>
                  </FormControl >
                </Grid>
                <Grid size={{ xs: 6, sm: 2, md: 2 }} >
                  <FormControl fullWidth disabled={isLoading}>
                    <InputLabel id="demo-simple-select-label">Tipo</InputLabel>
                    <Select
                      variant="outlined"
                      native={false}
                      value={tipoConfrontoFiltro}
                      label="Tipo Confronto"
                      onChange={(e) => setTipoConfrontoFiltro(Number(e.target.value))}
                    >
                      <MenuItem value={0}>Selecione</MenuItem>
                      {
                        tipoConfronto.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                      }

                    </Select>
                  </FormControl >
                </Grid>
                <Grid size={{ xs: 6, sm: 3, md: 3 }} display={"flex"} justifyContent={"end"} alignSelf={"center"}>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={carregarDadosHistoricoConfrontos}
                    startIcon={<Icon>change_circle</Icon>}
                  >
                    Pesquisar
                  </Button>
                </Grid>
              </Grid>
              <Grid size={{ xs: 12, sm: 12 }}>
                {isLoading && !removeLoading && <Loading />}
              </Grid>
              {(estatisticasRows.length > 0) && (
                <Grid size={{ xs: 12, sm: 12 }} paddingBottom={3}>
                  <Box sx={{
                    height: 'auto', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                    '& .super-app-theme--header': {
                      backgroundColor: theme.palette.common.black,
                      color: theme.palette.common.white,
                    },
                    '& .super-app.negative': {
                      color: 'red',
                      fontWeight: 'bold'
                    },
                    '& .super-app.positive': {
                      color: themeName === "light" ? "black" : "auto",
                    },
                    '& .super-app-theme--cell': {
                      color: '#00e676',
                      fontWeight: '600',
                    },
                    '& .MuiDataGrid-main': {
                      height: UtilidadeService.isMobile() ? "580px" : "maxValor",
                      overflow: UtilidadeService.isMobile() ? "overlay" : "hidden",
                    },
                    '& .MuiDataGrid-columnHeaders ': {
                      //position: UtilidadeService.isMobile() ? "fixed" : "relative",
                      zIndex: UtilidadeService.isMobile() ? 999 : "auto",
                    }
                  }}>
                    <DataGrid
                      localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                      getRowId={(i) => i.codigo}
                      rows={estatisticasRows}
                      columns={tipoFiltro.toString() === "1" ? columnsGeral : columnsGeralUsuario}
                      initialState={{
                        pagination: {
                          paginationModel: {
                            pageSize: 16,
                          },
                        },
                      }}
                      pageSizeOptions={[16, 25, 50, 100]}
                      disableDensitySelector
                      disableVirtualization
                      disableRowSelectionOnClick
                      disableColumnFilter
                      disableColumnMenu
                      sx={{
                        fontSize: UtilidadeService.isMobile() ? 11 : 16,
                      }}
                      //disableRowSelectionOnClick
                      onRowClick={handleRedirect}
                      hideFooter
                    />
                  </Box>
                </Grid>
              )}
              {(showDetalhes && detalhesEstatisticasRows.length > 0) && (
                <Grid size={{ xs: 12, sm: 12 }}  >
                  <Box sx={{
                    height: 'auto', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                    '& .super-app-theme--header': {
                      backgroundColor: theme.palette.common.black,
                      color: theme.palette.common.white,
                    },
                    '& .super-app.negative': {
                      color: 'red',
                      fontWeight: 'bold'
                    },
                    '& .super-app.positive': {
                      color: themeName === "light" ? "black" : "auto",
                    },
                    '& .super-app-theme--cell': {
                      color: '#00e676',
                      fontWeight: '600',
                    },
                  }}>
                    <DataGrid
                      localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                      getRowId={(i) => i.codigo}
                      rows={detalhesEstatisticasRows}
                      columns={columnsGeralUsuarioDetalhes}
                      initialState={{
                        pagination: {
                          paginationModel: {
                            pageSize: 16,
                          },
                        },
                      }}
                      pageSizeOptions={[16, 25, 50, 100]}
                    //disableRowSelectionOnClick

                    />
                  </Box>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </LayoutBaseDePagina>
  )
}

